import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import DetailsTab from './components/DetailsTab';
import OrderHistoryTab from './components/OrderHistoryTab';
import usePageTitle from 'hooks/usePageTitle';
import NoImage from 'assets/images/no-image.png';
import useIsMobile from 'utils/isMobileUtils';
import StatusBadge from 'ui-component/StatusBadge';



const SerialsDetails = () => {
	const [setPageTitle] = usePageTitle('Serials Details');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const { id } = useParams();
	const [activeComponent, setActiveComponent] = useState('Details');
	const history = useNavigate();
	const [serialDetails, setSerialDetails] = useState();
	const [repairLists, setRepairLists] = useState();
	const [defaultThumbnail, setDefaultThumbnail] = useState('');
	const [customThumbnail, setCustomThumbnail] = useState('');
	const [isLoading, setIsloading] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false)


	const getSerialsDetails = () => {
		setIsloading(true);
		api.getSerialsDetails(id).then((res) => {
			setIsloading(false);
			setSerialDetails(res.data?.stock);
			setCustomThumbnail(res.data?.stock?.product?.custom_thumbnail_url);

			res?.data?.stock?.product?.thumbnails?.map((thumbnail) => {
				if (thumbnail?.is_default == 1) {
					setDefaultThumbnail(thumbnail?.thumbnail_url);
				}
			});
			setRepairLists(res.data?.repairs);
			setIsDataLoaded(true)
		});
	};

	const handleComponentChange = (component) => {
		setActiveComponent(component);
	};



	useEffect(() => {
		getSerialsDetails();
	}, []);

	const isMobile = useIsMobile();


	return (
		<>
			<div className="row">
				<div className="col-12">
					<div className="row pb10">
						<div className="col-12">
							<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
								<div className="header-bubble" />
								<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
									<div
										style={{
											position: 'relative',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											minHeight: 38 // ensures enough height for the button
										}}
									>
										{' '}
										<button
											type="button"
											aria-label="Back"
											onClick={() => history(-1)}
											className="circle-back-btn"
											style={{
												position: 'absolute',
												left: 20,
												top: '50%',
												transform: 'translateY(-50%)'
											}}
										>
											{/* Replace with your fi arrow icon, example below */}
											<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
												<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
										</button>
										<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}>{serialDetails?.imei}</h5>
									</div>
									<div style={{ height: 30, opacity: 0 }}></div>
								</div>
							</div>
							<div className="section-head hide-on-mobile">
								<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px' }}>{serialDetails?.imei}</h2>

								<div className="actions">
									<div style={{ width: '90px' }}>
										<StatusBadge itemStatus={serialDetails?.status === 'inbound' ? 'Available' : 'Not Available'} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row mobile-scroll-container">
				<div className="col-12">
					<div className={`${isMobile ? ' ' : 'card p-2'}`}>
						<div className="content pad15">
							<div className="row m-0 p-0 mb-3 hide-on-mobile">
								<div className="col-md-2 col-sm-3 col-12">
									{defaultThumbnail ? (
										<img src={defaultThumbnail} className="product-thumbnail" alt="product" style={{ marginLeft: '10px' }} />
									) : customThumbnail ? (
										<img src={customThumbnail} className="product-thumbnail" alt="product" style={{ marginLeft: '10px' }} />
									) : (
										<img src={NoImage} alt="product" style={{ width: '70px', height: '100px' }} />
									)}
								</div>
								<div className="col-md-8 col-sm-9 col-12 product-header-summary">
									<div className="row">
										<div className="col-12">
											<div className="row form-group">
												<div className="col-12">
													{
														isMobile ? (
															<div className="form-section">
																<div className="">
																	<h4 style={{ fontSize: '18px !important', textAlign: 'center' }}>
																		<b>{serialDetails?.product?.name}</b>
																	</h4>
																</div>
															</div>
														) : (
															<div className="row">
																<div className="col-12">
																	<div className="row form-group product-preview-stock-labels">
																		<div className="col-12">
																			<div className="row">
																				<div className="col-md-12">
																					<div className="product-section-head " style={{ paddingBottom: '0px' }}>
																						<span style={{ fontSize: '18px' }}>{serialDetails?.product?.name}</span>
																					</div>
																				</div>
																			</div>
																			<div className="row">
																				<div className="col-md-12">
																					<div className={`badge2 badge-light-gray2`} style={{ fontWeight: '500', color: '#000' }}>
																						{serialDetails?.imei}
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														)
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="show-on-mobile">
								<div
									style={{ display: 'flex', marginBottom: '10px', gap: 10, flexDirection: 'column', alignItems: 'center', width: '100%' }}
								>
									<img
										src={defaultThumbnail ? defaultThumbnail : customThumbnail ? customThumbnail : NoImage}
										alt="product"
										style={{
											width: 'auto',
											height: '150px',
											maxWidth: '120px',
											objectFit: 'contain',
											borderRadius: 8,
											background: '#f8f8f8'
										}}
									/>
									<h4 className="fw600" style={{ fontSize: 18, marginBottom: 0 }}>
										{serialDetails?.product?.name}
									</h4>
									<div style={{ display: 'flex' }}>
										<div style={{ padding: '5px 10px', background: 'rgb(240 239 239)', borderRadius: 8, fontSize: 12 }}>
											IMEI: {serialDetails?.imei ?? 'No IMEI'}
										</div>
									</div>
									{serialDetails?.transactions?.[0]?.warranty && (
										<div style={{ display: 'flex' }}>
											<div style={{ padding: '5px 10px', background: '#818181', color: 'white', borderRadius: 8, fontSize: 12 }}>
												Warranty: {serialDetails?.transactions?.[0]?.warranty ?? 'No Warranty'}
											</div>
										</div>
									)}
								</div>
							</div>

							{!isMobile ? (
								<div className="row mt20">
									<div className="col-12">
										<ul className="topListCom">
											<li
												className={`${activeComponent === 'Details' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
												style={{ fontWeight: '500' }}
												onClick={() => {
													!isLoading && handleComponentChange('Details');
												}}
											>
												General
											</li>
											<li
												className={`${activeComponent === 'History' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
												style={{ fontWeight: '500' }}
												onClick={() => {
													!isLoading && handleComponentChange('History');
												}}
											>
												History
											</li>
											<li
												className={`${activeComponent === 'Repairs' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
												style={{ fontWeight: '500' }}
												onClick={() => {
													!isLoading && handleComponentChange('Repairs');
												}}
											>
												Repairs
											</li>
										</ul>

										<hr style={{ marginTop: '-1px' }} />
									</div>
								</div>
							) : (
								<div style={{ margin: '16px 0' }}>
									<Select
										value={{
											value: activeComponent,
											label: {
												Details: 'Details',
												History: 'History',
												Repairs: 'Repairs'
											}[activeComponent]
										}}
										onChange={(option) => !isLoading && handleComponentChange(option.value)}
										options={[
											{ value: 'Details', label: 'Details' },
											{ value: 'History', label: 'History' },
											{ value: 'Repairs', label: 'Repairs' }
										]}
										isDisabled={isLoading}
										styles={{
											control: (base, state) => ({
												...base,
												background: '#f5f5f5',
												borderColor: '#e0e0e0',
												minHeight: 38,
												borderRadius: 8,
												boxShadow: state.isFocused ? '0 0 0 1px #bdbdbd' : base.boxShadow,
												color: '#333'
											}),
											singleValue: (base) => ({
												...base,
												color: '#333'
											}),
											menu: (base) => ({
												...base,
												zIndex: 9999
											})
										}}
										isSearchable={false}
									/>
								</div>
							)}

							{activeComponent === 'Details' ? (
								<DetailsTab serialDetails={serialDetails} repairLists={repairLists} dataLoaded={isDataLoaded} />
							) : activeComponent == 'History' ? (
								<OrderHistoryTab
									serialDetails={serialDetails}
									// backorders={backorders}
								/>
							) : (
								''
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SerialsDetails;
